import React, { useMemo } from 'react';
import Sources from './Sources';

/**
 * Free-text release search, with no catalog title behind it.
 *
 * This is the same ranked list the title page shows, asked by name instead of
 * by IMDb id — the fallback when there's no TMDB key, and the escape hatch for
 * anything the catalog doesn't know about.
 */
const ReleaseSearch = ({ query }) => {
  // Sources refetches when this identity changes, so it has to be stable.
  // `any` rather than `movie`: there is no catalog entry here saying which this
  // is, and calling it a film excluded every TV-only indexer — so searching a
  // show by name returned films that happened to match the words in its title.
  const title = useMemo(() => ({ name: query, type: 'any' }), [query]);

  return <Sources title={title} />;
};

export default ReleaseSearch;
